import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import ReactPlayer from 'react-player';
import { Link } from 'react-scroll'
import HtmlParser from 'html-react-parser';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';

//import Modal from 'react-bootstrap/Modal';
//import Button from 'react-bootstrap/Button';
//import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';

class WistiaPlayer extends React.Component {

    componentDidMount  = () => {
		const script = document.createElement("script");
		script.src = "https://fast.wistia.com/embed/medias/y5e571x63d.jsonp";
		script.async = true;
		document.body.appendChild(script);

		const script2 = document.createElement("script");
		script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
		script2.async = true;

		document.body.appendChild(script2);	
	}


	render() {
		return (
            <div className="wistia_responsive_padding" style={{padding:"56.25% 0 0 0", margin: "0 0 20px 0", position:"relative", width:"100%"}}>
            <div className="wistia_responsive_wrapper" style={{height: "100%", left: "0", position: "absolute", top: "0", width: "100%"}}>
                <div className="wistia_embed wistia_async_y5e571x63d videoFoam=true" style={{height: "100%", position: "relative", width: "100%"}}>
                    <div className="wistia_swatch" style={{height:"100%", left:"0", opacity:"0", overflow:"hidden", position:"absolute", top:"0", transition:"opacity 200ms", width:"100%"}}>
                        <img src="https://fast.wistia.com/embed/medias/y5e571x63d/swatch" style={{filter:"blur(5px)", height:"100%", width:"100%"}} alt="Introduction to CQL ChartHop Webinar" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </div>

		);
	}
}


const Home = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;

    return (
        <Layout bodyClass="page-home covid-support" ontouchstart>
            <SEO title="Webinar | How HR can empower managers to lead | ChartHop" />
            <Helmet>
                <meta
                    name="description"
                    content="Tune in to this webinar with industry experts from ChartHop, Sapling, and Figma to learn how to empower managers with people data."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Webinar | How HR can empower managers to lead | ChartHop"/>
                <meta property="og:description" content="Tune in to this webinar with industry experts from ChartHop, Sapling, and Figma to learn how to empower managers with people data." />
                <meta property="og:image" content={`https://www.charthop.com/landings/210225-empowermanagers-webinar-thumbnail.png`} />
                <meta property="og:type" content="website" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Webinar | How HR can empower managers to lead | ChartHop" />
                <meta name="twitter:description" content="Tune in to this webinar with industry experts from ChartHop, Sapling, and Figma to learn how to empower managers with people data." />
                <meta name="twitter:image" content={`https://www.charthop.com/landings/210225-empowermanagers-webinar-thumbnail.png`} />
                <meta name="twitter:card" content="summary_large_image" />

            </Helmet>

            {/* PAGE CONTENT */}

            <section className="intro container introductionVideoPage">
                <div className="row align-items-center">
                    <div className="introducing-charthop-video col-12">
                        <h2>Leveraging data and technology to empower managers during unprecedented times</h2>
                        
                        <p className="pt-1 pb-1">Learn how HR can use data and technology to best support and empower our managers as they continue to lead their teams in this restless world.</p>

                        <WistiaPlayer/>

                        <p className="pt-1 pb-1"> In this webinar you will learn:
                        <li> What is HR’s role in developing good Managers and helping them succeed</li>
                        <li> How HR can use technology and data to support Managers with ongoing obstacles and challenges</li>
                        <li> How to foster a culture of trust</li>
                        <li> Tips to motivate and inspire remotely</li>
                       
                        Tune in and listen to our panelists Maria Barrera, Head of Marketing @ ChartHop, Kevin O'Connell, Head of Marketing @ Sapling, and Nadia Singer, Director of Talent @ Figma. 
                        </p>

                        
                    </div>
                </div>
            </section>


            
			<section className="customer testimonial-container pt-8 pb-5">
                 <JoinHappyCustomers title={HtmlParser('Supporting these <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
            </section>



            {/* CONTACT FORM */}

            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={HtmlParser("webinar-empowering-managers-sapling-demo")} headertext={HtmlParser("<h2>Your data shouldn't live in spreadsheets.<br><br>Empower your managers with ChartHop.</h2>")}/>
            </section>


        </Layout>
    );
};


export default Home;


export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;